import * as React from 'react';
import { useCurrentRefinements, useClearRefinements } from 'react-instantsearch';
import { Button } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { useItemsToClear } from '../../hooks/use-items-to-clear.js';

const ClearRefinements = ()=>{
    const { getLabel  } = useIntl();
    const { items  } = useCurrentRefinements();
    const itemsToClear = useItemsToClear(items);
    const { refine , canRefine  } = useClearRefinements({
        includedAttributes: itemsToClear.map((item)=>item.attribute
        )
    });
    if (!canRefine) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(Button, {
        className: "clear-refinements",
        onClick: refine,
        caption: getLabel('search.filters.clearAll'),
        variant: "ghost",
        size: "custom",
        "data-t": "clear-refinements-button"
    });
};

export { ClearRefinements as default };
//# sourceMappingURL=ClearRefinements.js.map
